import { render, staticRenderFns } from "./BindPictureEdit.vue?vue&type=template&id=453af25a&scoped=true"
import script from "./BindPictureEdit.vue?vue&type=script&lang=js"
export * from "./BindPictureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453af25a",
  null
  
)

export default component.exports